import React from 'react';
import { FormCard, FormDescriptions, supplierDefs } from '@purchase/supplier';
import { Space, Tag } from '@bedrock/components';
import { formatDate, formatMoneyAmount } from '../format';
import { SERVICE_TAG_CLASSNAME } from '../constants';

/** 区块5：处理方案 */
const HandlePlanBlock = ({ detail }: { detail?: supplierDefs.HandlePlanDto }) => {
  return (
    <FormCard title="处理方案拟定" proCardProps={{ expandable: true }}>
      <FormDescriptions columns={2} labelStyle={{ width: 180 }} margin={false}>
        <FormDescriptions.Item label="产品名称" span={2}>
          <span className="[word-break:break-word]">{detail?.productName || '--'}</span>
        </FormDescriptions.Item>
        <FormDescriptions.Item label="合同或约定条款" span={2}>
          <span className="[word-break:break-word]">{detail?.contractClause || '--'}</span>
        </FormDescriptions.Item>
        <FormDescriptions.Item label="条款内容" span={2}>
          <span className="[word-break:break-word]">{detail?.clauseContent || '--'}</span>
        </FormDescriptions.Item>
        <FormDescriptions.Item label="处理类型">
          {detail?.handleTypes?.length ? (
            <Space size={4} wrap>
              {detail.handleTypes.map((t) => (
                <Tag key={t} color="light-blue" size="xSmall" text={t} />
              ))}
            </Space>
          ) : (
            <span>--</span>
          )}
        </FormDescriptions.Item>
        <FormDescriptions.Item label="调整后等级">
          {detail?.adjustedGrade ? (
            <div className="flex flex-wrap gap-1">
              <span className={SERVICE_TAG_CLASSNAME}>{detail.adjustedGrade}</span>
            </div>
          ) : (
            <span>--</span>
          )}
        </FormDescriptions.Item>
        <FormDescriptions.Item label="核减合同应付款（万元）" span={2}>
          <span className="font-bold text-[#E08216]">{formatMoneyAmount(detail?.deductionAmount)}</span>
        </FormDescriptions.Item>
        <FormDescriptions.Item label="整改要求">
          {detail?.rectifyRequirements?.length ? (
            <div className="flex flex-wrap gap-1">
              {detail.rectifyRequirements.map((t) => (
                <span key={t} className={SERVICE_TAG_CLASSNAME}>
                  {t}
                </span>
              ))}
            </div>
          ) : (
            <span>--</span>
          )}
        </FormDescriptions.Item>
        <FormDescriptions.Item label="整改时限">
          <span>{formatDate(detail?.rectifyDeadline)}</span>
        </FormDescriptions.Item>
      </FormDescriptions>
    </FormCard>
  );
};

export default HandlePlanBlock;
